import { GlIcon, GlAvatar, GlAvatarsInline, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { getTimeago } from '~/lib/utils/datetime/timeago_utility';
import { n__ } from '~/locale';
export default {
    name: 'MergeRequestListItem',
    components: {
        GlIcon,
        GlAvatar,
        GlAvatarsInline
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        mergeRequest: {
            type: Object,
            required: true
        }
    },
    computed: {
        formattedTime () {
            return getTimeago().format(this.mergeRequest.createdAt);
        },
        assignees () {
            const assignees = this.mergeRequest.assignees?.nodes;
            return assignees.length ? assignees : [
                this.mergeRequest.author
            ];
        },
        assigneesBadgeSrOnlyText () {
            return n__('%d additional assignee', '%d additional assignees', this.assignees.length - this.$options.MAX_VISIBLE_ASSIGNEES);
        }
    },
    MAX_VISIBLE_ASSIGNEES: 3
};
